exports.cpf = require('./cpf');
exports.cnpj = require('./cnpj');